<template>
  <div ref="CardPaymentAcceptance" class="grid-module card-payment-acceptance">
    <h1>Boost Your Sales: Accept Credit Card Payments with Stripe Connect. </h1>
    <section>
      <div class="banner">
        <div class="banner_bg">
          <img
              src="../assets/card-payment-acceptance.png"
              alt="Card Payment Acceptance"
          >
        </div>
        <div class="banner_content" >
          <h2 >
            <span> Your Connect account</span>
          </h2>
          <p v-html="this.pText"></p>
          <p v-if="this.paymentStatus==='Enabled' &&
          (this.onePageNotCcAcceptance || !this.hasPages)">
            {{bannerText[this.status].note}}</p>
          <span v-if="(this.paymentStatus==='Canceled'
                        || this.paymentStatus==='Renewed' || !this.contractorId)">
            <b-tooltip target="disabled-wrapper"
              label="Unfortunately, your subscription has expired and this
              functionality is no longer available."
              class="block-tooltip is-gray"
              type="is-info"
              size="is-small"
              :delay="50"
              position="is-left"
              :content-class="'pre-line'"
              animated
              multilined>
              <b-button class="is-success"
                        :disabled="(this.paymentStatus==='Canceled'
                          || this.paymentStatus==='Renewed' || !this.contractorId)"
                        id="disabled-wrapper">
                {{bannerText[this.status].button_text}}
              </b-button>
            </b-tooltip>
          </span>
          <span v-else >
            <b-button class="is-success" :disabled="this.isClicked"
                      v-if="this.status === 'new_account'" @click="createAccount">
              {{bannerText[this.status].button_text}}
            </b-button>
            <b-button class="is-success"
                      v-if="this.status === 'restricted_account'
                        || this.status === 'restricted_soon_account'
                        || this.status === 'rejected_account'" @click="manageAccount">
              {{bannerText[this.status].button_text}}
            </b-button>
            <b-button class="is-success"
                      v-if="this.status === 'in_review_account'
                        || this.status === 'enabled_account'" @click="goToAccount">
              {{bannerText[this.status].button_text}}
            </b-button>
          </span>
        </div>
      </div>
    </section>

    <div class="disclaimer">Disclaimer: Enhancify does not store any financial or sensitive user
      data provided through Stripe Connect. All payment services are provided by Stripe Connect,
      a secure payment processor. When you have connected your own Stripe account, all collected
      payments go into your Stripe account. Enhancify has no visibility of or access to your
      Stripe account. Payouts to your bank account are done directly
      by Stripe.</div>

    <section>
      <div class="stripe-connect">
        <h2>Why Stripe Connect is the best choice for your business</h2>
        <div class="blocks">
          <div class="block" v-for="(block, index) in blockData.show" :key="index">
            <StripeConnectBlock
                :iconName="block.iconName"
                :title="block.title"
                :bullets="block.bullets"
            />
          </div>
        </div>
        <b-button v-if="!showBlocks" class="show-more is-success"
                  @click="showBlocks=!showBlocks">SHOW MORE</b-button>

        <div v-if="showBlocks" class="blocks">
          <div class="block" v-for="(block, index) in blockData.hide" :key="index">
            <StripeConnectBlock
                :iconName="block.iconName"
                :title="block.title"
                :bullets="block.bullets"
            />
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="how_mach">
        <div class="title">
          How much is Stripe Connect?
        </div>
        <p>The <a href=" https://stripe.com/connect/pricing" target="_blank">standard pricing</a>
          is <span>2.9% + 30¢</span> per successful transaction for domestic cards.
          There are no setup fees, monthly fees, or hidden fees.</p>
        <div class="disclaimer">Prices actual as of {{ previousMonthYear }}</div>
      </div>
    </section>

    <section>
      <div class="why-stripe">
        <div class="title">Stripe Connect & Enhancify</div>
        <img src="@/assets/img/stripe.png" alt="stripe + enhancify">
        <p>
          Start accepting credit card payments and expand financing options for your clients.
          Enhancify offers 0% Financing for up to 21 months for qualified clients through credit
          cards.
        </p>
        <p>
          If you do not accept credit card payments yet, we have a solution for you – let Stripe
          Connect process credit card payments while you concentrate on growing your business
        </p>
        <div class="grey-line"></div>
        <div class="questions">Still have questions?
          <a href=" https://stripe.com/connect" target="_blank">Go to Stripe Connect</a>.
        </div>
      </div>
    </section>
    <preloader :is-preloading='isPreloading'></preloader>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { toLower } from 'lodash';
import StripeConnectBlock from '../components/CardPaymentAcceptance/StripeConnectBlock.vue';
import StripeConnectBlockData from '../components/CardPaymentAcceptance/StripeConnectBlockData';
import {
  contractorsConnectedAccount,
  contractorCreateConnectedAccount,
  contractorRefreshConnectedAccount,
  contractorSuccessConnectedAccount,
} from '../api/contractor';
import Preloader from '../components/Preloader.vue';

export default {
  name: 'CardPaymentAcceptance',
  components: { Preloader, StripeConnectBlock },
  connectedAccount: null,

  data() {
    return {
      iconName: String,
      title: String,
      bullets: Array,
      blockData: {},
      showBlocks: false,
      text: null,
      note: null,
      button_text: null,
      button_url: null,
      status: 'new_account',
      accountId: null,
      onePageNotCcAcceptance: false,
      hasPages: false,
      hasParam: false,
      pText: null,
      isClicked: false,
      isPreloading: false,
      bannerText: {
        new_account: {
          text: 'Start accepting credit card payments from your clients to increase your '
            + 'sales and improve client experience.<br>'
            + 'Use Stripe Connect to process credit card payments. ',
          button_text: 'JOIN STRIPE CONNECT',
        },
        restricted_account: {
          text: 'You haven’t finished setting up your Stripe account.<br>'
            + 'Please complete your Stripe '
            + 'account setup to start accepting credit card payments.',
          button_text: 'MANAGE STRIPE CONNECT',
        },
        restricted_soon_account: {
          text: 'Your Stripe account needs attention.<br>'
              + 'Please log in to your Stripe account to address '
              + 'issues and avoid interruptions in your work.',
          button_text: 'MANAGE STRIPE CONNECT',
        },
        rejected_account: {
          text: 'Your Stripe Connect account is on pause.<br>'
              + 'Please log in to your Stripe account to address '
              + 'issues and avoid disruptions to capabilities.',
          button_text: 'MANAGE STRIPE CONNECT',
        },
        in_review_account: {
          text: 'Congratulations! You’ve successfully created your Stripe Connect account.<br>'
              + 'Stripe will review the information you provided to complete the process. '
              + 'The review process can take 2-3 business days.',
          button_text: 'GO TO STRIPE CONNECT',
        },
        enabled_account: {
          text: 'You are all set up to start accepting credit card payments!<br>'
              + 'Now you can go to your Stripe Connect account to get a link to a payment page.',
          note: '(Note: Please visit your Enhancify dashboard to update your page settings: go to Co-branded '
              + 'Page => Credit card acceptance*=> select “Yes”.)',
          button_text: 'GO TO STRIPE CONNECT',
        },
      },
    };
  },
  computed: {
    ...mapState('user', { userId: (state) => state.id }),
    ...mapState('contractor', { contractorId: (state) => state.id, paymentStatus: (state) => state.paymentStatus }),
    ...mapGetters(['isSwitched', 'userAuthenticator', 'authAuthenticator']),
    previousMonthYear() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      return date.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    },
  },

  created() {
    const param = this.$route.query.action;
    if (param) {
      if (param === 'refresh') {
        this.refreshAccount();
      }
      if (param === 'success') {
        this.successAccount();
      }
    }
  },
  mounted() {
    this.getContractorsConnectedAccount();
    this.blockData = StripeConnectBlockData;
  },
  watch: {

  },
  methods: {
    getContractorsConnectedAccount() {
      contractorsConnectedAccount(this.contractorId)
        .then((response) => {
          this.connectedAccount = response.data;
          if (this.connectedAccount.length === 0) {
            this.status = 'new_account';
            this.accountId = null;
            this.onePageNotCcAcceptance = false;
            this.hasPages = true;
          }
          if (this.connectedAccount && this.connectedAccount.status !== null) {
            this.status = `${toLower(this.connectedAccount.status)}_account`;
            if (this.connectedAccount.status === 'Restricted soon') {
              this.status = 'restricted_soon_account';
            }
            if (this.connectedAccount.status === 'In review') {
              this.status = 'in_review_account';
            }
            this.accountId = this.connectedAccount.accountId;
            this.onePageNotCcAcceptance = this.connectedAccount.onePageNotCcAcceptance;
            this.hasPages = this.connectedAccount.hasPages;
          }
          this.pText = this.bannerText[this.status].text;
        }).catch((error) => {
          this.error = error;
          this.status = 'new_account';
          this.accountId = null;
          this.onePageNotCcAcceptance = false;
          this.hasPages = true;
          this.pText = this.bannerText[this.status].text;
        });
    },
    createAccount() {
      this.isClicked = true;
      contractorCreateConnectedAccount(this.contractorId)
        .then((response) => {
          this.connectedAccount = response.data;
          if (this.connectedAccount) {
            if (this.connectedAccount.status !== null) {
              this.status = `${toLower(this.connectedAccount.status)}_account`;
              if (this.connectedAccount.status === 'Restricted soon') {
                this.status = 'restricted_soon_account';
              }
              if (this.connectedAccount.status === 'In review') {
                this.status = 'in_review_account';
              }
              window.open(this.connectedAccount.accountLink, '_blank', 'noopener,noreferrer');
            }
          }
          this.isClicked = false;
        }).catch((error) => {
          this.error = error;
          this.isClicked = false;
        });
    },
    refreshAccount() {
      this.isPreloading = true;
      contractorRefreshConnectedAccount(this.contractorId)
        .then((response) => {
          this.connectedAccount = response.data;
          window.open(this.connectedAccount.accountLink, '_self', 'noopener,noreferrer');
        }).catch((error) => {
          this.error = error;
        }).finally(() => { this.isPreloading = false; });
    },

    successAccount() {
      contractorSuccessConnectedAccount(this.contractorId)
        .then((response) => {
          this.connectedAccount = response.data;
          this.status = `${toLower(this.connectedAccount.status)}_account`;
        }).catch((error) => {
          this.error = error;
        });
    },
    manageAccount() {
      if (this.connectedAccount && this.connectedAccount.accountLink) {
        window.open(this.connectedAccount.accountLink, '_blank', 'noopener,noreferrer');
      } else {
        window.open('https://dashboard.stripe.com/login', '_blank', 'noopener,noreferrer');
      }
    },
    goToAccount() {
      window.open('https://dashboard.stripe.com/login', '_blank', 'noopener,noreferrer');
    },
  },
};
</script>

<style scoped lang="css">
.card-payment-acceptance{
  padding:0 18px 0 18px;
  color: #293033;
}
.banner {
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
  background-clip: padding-box;
  border: solid 3px transparent;
  background-color: #fff;
  -webkit-box-shadow: 0 4px 10px rgba(0,0,0,0.25);
  box-shadow: 0 4px 10px rgba(0,0,0,0.25);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-bottom: 30px;
}
.banner:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  margin: -3px;
  background: -webkit-gradient(linear, left top, right top, from(#1c418c), to(#68ba62));
  background: linear-gradient(90deg, #1c418c 0%, #68ba62 100%);
}
.banner_bg{
  max-width: 342px;
  min-width: 175px;
  width: 25%;
  height: auto;
  background: linear-gradient(100deg, #1c418c 12.41%, #68ba62 106.24%, #68ba62 106.24%);
  background-position-x: 0%;
  background-position-y: 0%;
  background-blend-mode: hard-light;
  background-position: right 0;
  -webkit-clip-path: polygon(0 0, 100% 0, calc(100% - 40px) 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, calc(100% - 40px) 100%, 0 100%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 40px 40px 40px 20px;
}
.banner_bg img{
  width: 175px;
  height:auto;
}
.banner_content {
  padding: 20px 40px;
  width: 75%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.banner_content h2 {
  position: relative;
  display: inline-block;
}
.banner_content p{
  font-size: 20px;
  line-height: 28px;
}
.banner_content button{
  max-width: 300px;
  margin-top: 25px;
  background: #68ba62;
  height: 60px;
  font-size: 22px;
  line-height: 24px;
  font-weight: 500;
  color: white;
  border-color: transparent;
}
.disclaimer{
  font-size:16px;
  color: #DE4B4B;
  border-left:4px solid #DE4B4B;
  padding:10px;
}
.stripe-connect{
  border:1px solid #8FA7B3;
  padding: 32px 40px;
  margin-top:30px;
  margin-bottom: 30px;
}
.stripe-connect h2 {
  margin-bottom:0;
  color:#293033;
  font-size: 30px;
  line-height: 48px;
}
.stripe-connect .blocks {
  display:flex;
  flex-direction:row;
  padding-top:30px;
  margin-bottom:40px;
}
.stripe-connect .blocks:last-child{
  padding-top:0;
}
.stripe-connect .block{
  margin-right:50px;
  max-width:316px;
  width:25%;
  margin-bottom: 0;
}
.stripe-connect .block:last-child{
  margin-right:0;
}
.stripe-connect .show-more {
  width: 424px;
  height: 60px;
  margin: 0 auto 10px;
  position: relative;
  font-size: 22px;
  line-height: 24px;
  font-weight: 500;
  color: white;
  border-color: transparent;
  display: block;
  &:after{
    content:'';
    display:block;
    width:20px;
    height:20px;
    position:absolute;
    bottom:-10px;
    left:calc(50% - 10px);
    background: #68ba62;
    rotate: 135deg;
  }
}
.stripe-connect .show-more:hover:after{
  background-color: #17B548;
}
.block {
  & ul {
    display: flex;
    flex-direction: column;
    margin: 16px 0 0 -4px;
    padding-left: 28px;
    & li {
      margin: 0 0 18px 0;
      font-size: 18px;
      font-weight: 400;
      line-height: 25.2px;
      position: relative;
      color: #525F66;
      &:last-child {
        margin:0;
      }
      &:before {
        content: '';
        position: absolute;
        top: 7px;
        left: -28px;
        background-color: #68BA62;
        width: 10px;
        height: 10px;
        border-radius: 10px;
      }
    }
  }
}
.how_mach {
  width: 100%;
  position: relative;
  margin: 0 0 30px 0;
  padding: 40px;
  background-clip: padding-box;
  border: solid 3px transparent;
  background-color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.how_mach:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  margin: -3px;
  background: -webkit-gradient(linear, left top, right top, from(#1c418c), to(#68ba62));
  background: linear-gradient(90deg, #1c418c 0%, #68ba62 100%);
}
.how_mach .title {
  font-size: 30px;
  font-weight:700;
  margin-bottom:20px;
  color:#293033;
}
.how_mach p {
  font-size: 24px;
  font-weight:700;
  color: #525F66;
  margin:0 0 20px 0;
}
.how_mach p a {
  color: #056ED6;
  text-decoration: underline;
}
.how_mach p span {
  color: #68BA62;
}
.grey-line {
  height:1px;
  width:100%;
  background-color: #8FA7B3;
  margin:10px 0;
}
.why-stripe .title {
  font-size: 30px;
  font-weight:700;
  margin-bottom:20px;
  color:#293033;
}
.why-stripe {
  border:1px solid #8FA7B3;
  padding: 32px 40px 40px;
  margin-bottom: 30px;
}
.why-stripe p {
  color: #525F66;
  font-size: 18px;
  padding: 0 0 20px;
  width: 95%;
}
.why-stripe img {
  padding: 5px 0 20px;
}
.questions {
  color: #525F66;
  font-size: 24px;
  font-weight: 700;
  padding-top:20px;
}
.questions a {
  color: #056ED6;
  text-decoration: underline;
}
span.d-inline-block {
  display: inline-block;
}
.stripe-connect .block span {
  flex-direction: column;
  display: flex;
}

@media screen and (max-width: 1377px){
  .stripe-connect .blocks{
    flex-wrap: wrap;
  }
  .stripe-connect .block{
    max-width:316px;
    width:316px;
    margin-bottom: 40px;
  }
  .stripe-connect .block:nth-child(2) {
    margin-right: 0;
  }
}
.stripe-connect .block:nth-child(3) {
  margin-bottom: 0;
}
.stripe-connect .block:last-child {
  margin-bottom: 0;
}
@media screen and (max-width: 1170px) {
  .card-payment-acceptance {
    padding: 0 0px 0 0px;
  }

  .stripe-connect .block {
    max-width: 316px;
    width: calc(50% - 25px);
  }
}
@media screen and (max-width: 1023px) {
  .why-stripe {
    padding: 30px 40px;
  }
  .stripe-connect{
    padding: 32px 40px;
  }
  .banner_bg img {
    width: 124px;
  }
}

@media screen and (max-width: 769px) {
  .banner_bg {
    max-width: 214px;
    padding: 20px 40px 20px 20px;
  }
  .banner {
    border: solid 2px transparent;
  }
  .banner:before {
    margin: -2px;
  }
  .banner_content button{
    font-size: 20px;
    line-height: 24px;
    height: 55px;
  }
  .banner_content p{
    font-size: 18px;
    line-height: 25.2px;
  }
  .stripe-connect .block{
    margin-right:40px;
    max-width: 310px;
    width: calc(50% - 20px);
  }
  .stripe-connect{
    padding: 32px 30px;
  }
  .how_mach {
    padding: 20px 30px;
  }
  .stripe-connect h2 {
    font-size: 24px;
    line-height: 28px;
  }
  .how_mach .title{
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 10px;
  }
  .how_mach p{
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 18px;
  }

  .why-stripe {
    padding: 20px 30px;
  }
  .why-stripe .title{
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 10px;
  }
  .why-stripe img {
    height: auto;
    max-width: 219px;
  }
  .questions {
    font-size: 20px;
  }

  .block .title {
    margin-top: 20px;
  }
  .card-payment-acceptance h1 {
    font-size: 30px;
    line-height: 42px;
  }
  .stripe-connect .blocks {
    margin-bottom: 30px;
  }
  .banner_bg img {
    width: 120px;
  }
}

@media screen and (max-width: 600px) {
  .banner_bg {
    max-width: 100%;
    width: 100%;
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 40px), 0 100%);
    padding: 20px 20px 50px 20px;
  }

  .banner_bg img {
    width: 84px;
  }

  .banner {
    flex-direction: column;
  }

  .banner_content button {
    max-width: 221px;
    width: 100%;
    height: 48px;
    font-size: 18px;
    line-height: 24px;
    margin: 25px auto 0;
  }

  .banner_content {
    padding: 20px 40px;
    width: 100%;
    text-align: center;
  }

  .banner_content p {
    font-size: 16px;
    line-height: 22px;
  }

  .banner_content h2 {
    text-align: center;
  }

  .stripe-connect .show-more {
    width: 100%;
  }

  .stripe-connect .blocks {
    flex-direction: column;
    padding-top: 20px;
  }

  .stripe-connect .block {
    width: 100%;
    max-width: 100%;
    margin-bottom:30px;
  }

  .stripe-connect .block .icon {
    width: 40px;
    height: 40px;
  }

  .stripe-connect {
    padding: 20px 18px;
  }

  .stripe-connect h2 {
    font-size: 20px;
    line-height: 28px;
  }

  .card-payment-acceptance {
    font-size: 16px;
    line-height: 22.4px;
  }
  .why-stripe {
    padding: 20px 18px;
  }
  .why-stripe p{
    font-size: 16px;
    line-height: 22.4px;
  }
  .how_mach p {
    font-size: 18px;
    line-height: 25.2px;
  }
  .how_mach .title {
    font-size: 20px;
    line-height: 28px;
  }
  .why-stripe .title{
    font-size: 20px;
    line-height: 28px;
  }
  .block {
    & ul {
      & li {
        font-size: 16px;
        line-height: 22.4px;
        margin-bottom: 10px;
        &:before {
          top: 6px;
          left: -20px;
          width: 8px;
          height: 8px;
          border-radius: 8px;
        }
      }
    }
  }
  .banner_content button{
    max-width: 284px;
    margin-top: 25px;
    height: 48px;
    font-size: 18px;
    line-height: 24px;
  }
  .stripe-connect .show-more {
    width: 284px;
    height: 48px;
    margin: 20px auto 10px;
    position: relative;
    font-size: 18px;
    line-height: 24px;
    &:after{
      content:'';
      display:block;
      width:20px;
      height:20px;
      position:absolute;
      bottom:-10px;
      left:calc(50% - 10px);
      background: #68ba62;
      rotate: 135deg;
    }
  }
  .how_mach {
    padding:18px;
  }
  .questions {
    font-size: 18px;
  }
  .card-payment-acceptance h1 {
    font-size: 30px;
    line-height: 38px;
  }
  .stripe-connect .block:nth-child(3) {
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 361px) {
  .card-payment-acceptance h1 {
    font-size: 20px;
    line-height: 28px;
  }
}
</style>
